import { Link } from "react-router-dom";
import React from "react";
import { ScrollLocky } from "react-scroll-locky";
import Space from "./Space";
import { connect } from "react-redux";
import { logout } from "../actions/authActions";

const HomeNav = ({
  maxWidth = 1000,
  auth,
  dispatch,
  navOpen,
  phone,
  formattedPhone,
}) => (
  <header className="contain" style={{ maxWidth: `${maxWidth}px` }}>
    <Link className="logo bg-img" to="/" />
    <div id="appNav">
      <div className="mobile nav-btn">
        <div className="nav-btn-bar" />
      </div>{" "}
      <ScrollLocky enabled={navOpen} gapMode="padding">
        <nav className={`${navOpen ? "open-nav" : "close-nav"} homeNav`}>
          <div className="scrollable">
            <div className="mobile">
              <span className="close close-nav-btn" />
              <Space size={60} />
            </div>

            <a
              href="https://blog.buypower.ng"
              className="nav-item nav-item-home nav-item-merchant"
            >
              Blog
            </a>

            <Link to="/merchant" className="nav-item nav-item-home">
              Merchant
            </Link>

            <Link className="nav-item nav-item-home" to="#">
              Developers
            </Link>
            <Link className="nav-item nav-item-home" to="/faq">
              FAQ
            </Link>
            <Link to="/contact" className="nav-item nav-item-home">
              Contact Us
            </Link>

            {!auth && (
              <Link to="/login" className="nav-item nav-item-home button">
                Pay Bills
              </Link>
            )}
            {auth && (
              <Link
                className="nav-item nav-item-home button"
                onClick={(e) => {
                  dispatch(logout());
                }}
                to="/"
              >
                Log Out
              </Link>
            )}
          </div>
        </nav>
        <nav className="close-nav homeNav"></nav>{" "}
      </ScrollLocky>
    </div>
  </header>
);

export default connect((state) => ({
  auth: state.auth.authenticated,
  navOpen: state.nav.open,
  phone: state.settings.phone,
  formattedPhone: state.settings.formattedPhone,
}))(HomeNav);



// WEBPACK FOOTER //
// ./src/components/HomeNav.js